import { render, staticRenderFns } from "./AppointmentDataCard.vue?vue&type=template&id=bd04c26e&scoped=true&"
import script from "./AppointmentDataCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentDataCard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDataCard.vue?vue&type=style&index=0&id=bd04c26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd04c26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd04c26e')) {
      api.createRecord('bd04c26e', component.options)
    } else {
      api.reload('bd04c26e', component.options)
    }
    module.hot.accept("./AppointmentDataCard.vue?vue&type=template&id=bd04c26e&scoped=true&", function () {
      api.rerender('bd04c26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentDataCard/AppointmentDataCard.vue"
export default component.exports